export const defaultImageSize = 'big';
export const defaultColorMode = 'primaryLight';
export const defaultColor = 'primary';
